// extracted by mini-css-extract-plugin
export var askAiIcon = "_ns-j";
export var category = "_ns-9";
export var categoryHeader = "_ns-e";
export var container = "_ns-0";
export var group = "_ns-a";
export var groupItems = "_ns-f";
export var groupSeparator = "_ns-k";
export var loading = "_ns-1";
export var noResults = "_ns-3";
export var placeholder = "_ns-2";
export var resultContent = "_ns-5";
export var resultIcon = "_ns-c";
export var resultItem = "_ns-g";
export var resultMeta = "_ns-8";
export var resultSubtitle = "_ns-7";
export var resultSuffix = "_ns-i";
export var resultTitle = "_ns-6";
export var resultsList = "_ns-4";
export var searchGroup = "_ns-d";
export var selected = "_ns-h";
export var subgroup = "_ns-b";